import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const defaultAppState = {
    selectedMember: null,
  };
  const storedAppState = localStorage.getItem('appState');
  const [appState, setAppState] = useState(
    storedAppState ? JSON.parse(storedAppState) : defaultAppState,
  );

  const handleSetAppState = (appState) => {
    localStorage.setItem('appState', JSON.stringify(appState));
    setAppState(appState);
  };

  return (
    <AppContext.Provider value={{ appState, setAppState: handleSetAppState }}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within a AppProvider');
  }
  return context;
};
